import { PaymentMethodBrand } from 'types/PaymentMethod';

const path = '/images/creditCards/';

const icons: Record<PaymentMethodBrand, string> = {
    mastercard: `${path}icon-mastercard.svg`,
    visa: `${path}icon-visa.svg`,
    amex: `${path}icon-amex.svg`,
    discover: `${path}icon-credit-card.svg`,
    diners: `${path}icon-diners-club.svg`,
    unknown: `${path}icon-credit-card.svg`
};

const getCardIcon = (brand: PaymentMethodBrand): string => icons[brand] ?? icons.unknown;

export default getCardIcon;
